import { useSignalREvents } from './useSignalR'
import { SIGNALR_EVENTS } from '~/constants/signalREvents'
import { useAuthStore } from '~/stores/auth'
import { useNotificationsStore } from '~/stores/notifications'

export function useNewNotificationReceived() {
  const NotificationsStore = useNotificationsStore()
  const AuthStore = useAuthStore()
  const signalR = useSignalREvents()
  const handleNewNotificationReceived = async () => {
    await NotificationsStore.getDropdownNotifications()
    if (AuthStore.user) {
      AuthStore.user.hasUnviewedNotifications = true
    }
  }
  const handleOn = () => {
    signalR.on(
      SIGNALR_EVENTS.NOTIFICATION_HUB.NEW_NOTIFICATION_RECEIVED,
      handleNewNotificationReceived
    )
  }
  const handleOff = () => {
    signalR.off(
      SIGNALR_EVENTS.NOTIFICATION_HUB.NEW_NOTIFICATION_RECEIVED,
      handleNewNotificationReceived
    )
  }
  onMounted(() => {
    handleOn()
  })
  onUnmounted(() => {
    handleOff()
  })

  return {
    handleOff,
    handleOn,
  }
}
